import { AppEnvironmentEnum } from '@lib/shared';

export const environment = {
	appEnvironment: AppEnvironmentEnum.LIVE,

	production: true,

	apiServer: 'https://messe-api.lorenz-projekte.com',

	languages: ['de', 'en'] // The first language is default
};
